import { gql } from '@apollo/client';
import React from 'react';
import {
  MyAccountCreditCardListFields,
} from '../schemas/rql';
import MyAccountCreditCardEditForm, { MyAccountCreditCardEditFormFragment } from './MyAccountCreditCardEditForm';

type CreditCard = MyAccountCreditCardListFields.CreditCards;

interface Props {
  creditCards: CreditCard[];
}

export default function MyAccountCreditCardList({ creditCards }: Props) {
  return (
    <ul>
      {creditCards.map((creditCard) => (
        <li key={creditCard.id}>
          <div className="padding-4 mb-2 bd-1 bd-radius-primary bd--light-gray">
            <MyAccountCreditCardEditForm creditCard={creditCard} />
          </div>
        </li>
      ))}
    </ul>
  );
}

export const MyAccountCreditCardListFragment = gql`
  fragment MyAccountCreditCardListFields on rql_Me {
    creditCards {
      id
    }
    ...MyAccountCreditCardEditFormFields
  }
  ${MyAccountCreditCardEditFormFragment}
`;
